import { Directive, HostListener} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trTrimSpaces][ngModel], [trTrimSpaces][formControlName], [trTrimSpaces][formControl]',
})
export class TrimSpacesDirective  {
  constructor(
    private ngControl: NgControl,
  ) { }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    this.ngControl.control.setValue(value.trim());
  }
}
